



























import Vue from "vue";
import Slider from "@/components/app/Slider.vue";
import QuiqOperations from "@/components/app/QuiqOperations.vue";
import ChoosenPayments from "@/components/catalog/ChoosenPayments.vue";
import Transfers from "@/components/catalog/Transfers.vue";
import ContractsPanel from "@/components/contracts-panel/ContractsPanel.vue";
import MainNavigation from "@/components/navigation/MainNavigation.vue";
//import CurrencyRates from "@/components/app/CurrencyRates.vue";
import { getModule } from "vuex-module-decorators";
import { PersonStore } from "fs-pb-vue2/store/modules/person";
import { getPeriodOfDay } from "fs-pb-vue2/utilities/index";
//import { ConfigApi } from "fs-pb-vue2/services/api/ConfigApi";
import MapComponent from "@/components/app/MapComponent.vue";


/**Страница ифнормации по счету */
export default Vue.extend({
  components: {
    Slider,
    ChoosenPayments,
    Transfers,
    ContractsPanel,
    MainNavigation,
    QuiqOperations,
    MapComponent
    //CurrencyRates
  },
  computed: {
    personInfo(): any {
      const personStore: PersonStore = getModule(PersonStore, this.$store);
      return personStore.personInfo;
    },
    getPeriod(): string {
      return getPeriodOfDay();
    },
    windowWidthCalc(): number {
      return window.innerWidth;
    },
    preApprovedSolutionData() {
      return this.$store.state.config.preApprovedSolutionData;
    },
    getLinkOld(): string {
     return process.env.VUE_APP_OLD_URL
    },
  }
});
